import {
  FeatureFlagEnum,
  ModuleEnum,
  PermissionOperationEnum,
} from 'src/api/ProactApiClient';
import {routeRegistry} from 'src/pages/RouteRegistry';
import {KnowledgeArticleForm} from 'src/pages/Modules/KnowledgeBase/shared/KnowledgeArticleForm';
import {KnowledgeBaseDocumentTitle} from 'src/pages/Modules/KnowledgeBase/shared/knowledgeArticleHelpers';
import {PathUtility} from 'src/shared/constants/PathBuilder';
import useSetDocumentTitle from 'src/shared/hooks/useSetDocumentTitle';
import {ContentWrapper} from 'src/app/layout/ContentWrapper';

export const KnowledgeArticleCreatePage = () => {
  useSetDocumentTitle(KnowledgeBaseDocumentTitle);

  return (
    <ContentWrapper featureFlag={FeatureFlagEnum.KnowledgeBase}>
      <KnowledgeArticleForm mode="create" />
    </ContentWrapper>
  );
};

routeRegistry.registerPageRoute({
  backNavigation: 'form',
  path: PathUtility.KnowledgeBaseCreate(),
  element: <KnowledgeArticleCreatePage />,
  module: ModuleEnum.KnowledgeBase,
  operation: PermissionOperationEnum.Create,
  isPrivate: true,
});
